import type { I18NMessages } from '@atlaskit/intl-messages-provider/types';

import { locales } from '../../i18n';
import enMessages from '../../i18n/en';

export const defaultLocale: {
	'@atlassian/edition-benefits-modal.benefits-section.button.maybe-later': string;
	'@atlassian/edition-benefits-modal.benefits-section.button.try-it-free': string;
	'@atlassian/edition-benefits-modal.benefits-section.feature.text.help-center-customization.feature1': string;
	'@atlassian/edition-benefits-modal.benefits-section.feature.text.help-center-customization.feature2': string;
	'@atlassian/edition-benefits-modal.benefits-section.feature.text.help-center-customization.feature3': string;
	'@atlassian/edition-benefits-modal.benefits-section.feature.text.incidents-slack-integration.feature1': string;
	'@atlassian/edition-benefits-modal.benefits-section.feature.text.incidents-slack-integration.feature2': string;
	'@atlassian/edition-benefits-modal.benefits-section.feature.text.incidents-slack-integration.feature3': string;
	'@atlassian/edition-benefits-modal.benefits-section.heading.help-center-customization': string;
	'@atlassian/edition-benefits-modal.benefits-section.heading.incidents-slack-integration': string;
	'@atlassian/edition-benefits-modal.benefits-section.link.pricing': string;
	'@atlassian/edition-benefits-modal.benefits-section.subtitle': string;
	'@atlassian/edition-benefits-modal.button-trigger.open-modal': string;
	'@atlassian/edition-benefits-modal.premium-benefits-modal.try-it-free': string;
} = enMessages;

const localeMap: Record<string, string> = {
	pt: 'pt_BR',
	'pt-PT': 'pt_BR',
	'en-AU': 'en_GB',
};

export const fetchMessagesForLocale = async (locale: string): Promise<I18NMessages | undefined> => {
	try {
		const targetLocale = (localeMap[locale] ?? locale ?? '').replace('-', '_');

		if (!targetLocale) {
			throw new Error('No mapped locale');
		}

		const messages = await locales[targetLocale]();
		return messages.default;
	} catch {
		// ignore
	}

	try {
		const parentLocale = locale.split(/[-_]/)[0];
		const messages = await locales[parentLocale]();
		return messages.default;
	} catch {
		// ignore
	}

	/**
	 * English bundled by default as this is the majority of users
	 */
	return defaultLocale;
};
